import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventEntityId,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
// @ts-ignore
import EntityDefaultVarietyShortNameValue from 'components/EntityDefaultVarietyShortNameValue';

// Global Selectors
import { makeSelectHarvestEventEntityId } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    entityId?: HarvestEventEntityId;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventVarietyShortNameValueComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { entityId } = this.props;
        if (entityId) {
            return <EntityDefaultVarietyShortNameValue entityId={entityId} />;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectHarvestEventEntityId()
});

export default connect(mapStateToProps)(
    HarvestEventVarietyShortNameValueComponent
);
